import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import FontHeading1 from "../../../../components/fonts/font-heading1/font-heading1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import GridLineLayout from "../../../../components/layouts/grid-line-layout/grid-line-layout";
import GridLine, { BackgroundColor } from "../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineItem from "../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import { INotificationDescription, INotificationItemDescription } from "../../../../services/api/email-content-service";
import './variables-and-events.scss';
import emailContentDescriptionStore from "../../stores/email-content-description-store";

const VariablesAndEvents: React.FC = observer(() => {

    const RETURNS = 'Returns';
    const VARIABLES = 'variables';
    const EVENTS = 'events';
    const [tabContent, setTabContent] = useState<INotificationItemDescription[]>([]);
    const [selectedTab, setSelectedTab] = useState<string>(`${RETURNS}/${EVENTS}`)
    const [categories, setCategories] = useState<INotificationDescription[]>();
    const [selectedCategory, setSelectedCategory] = useState<string>(RETURNS)

    useEffect(() => {
        const fetchData = async () => {
            return await emailContentDescriptionStore.load();
        };

        fetchData().then(() => {
            setCategories(emailContentDescriptionStore.categories)
            setTabContent(emailContentDescriptionStore.categories[0].events)
        });

    }, [setTabContent])

    const handleOnClick = (category: string,content: string, items: INotificationItemDescription[]) => {
        setSelectedCategory(category);
        setSelectedTab(`${category}/${content}`);
        setTabContent(items);
    };

    return (<div className="variables-and-events">
        <div className="header">
            <div className="logo" />
        </div>

        <div className="title">
            <FontHeading1>RMA Variables & Events</FontHeading1>
        </div>
        <div className="layout">
            <div className="sidebar">
                <ul>
                    {categories?.map((category) => (<li key={category.category}>
                         <FontBody1 variant={(selectedCategory === category.category)?FONT_VARIANT.BOLD: FONT_VARIANT.DEFAULT}>{category.category}</FontBody1>
                             <ul>
                                 <li onClick={() => handleOnClick(category.category,EVENTS, category.events)}>
                                     <FontBody1 variant={(selectedTab === `${category.category}/${EVENTS}`) ? FONT_VARIANT.BOLD : FONT_VARIANT.DEFAULT}>Events</FontBody1>
                                 </li>
                                 <li onClick={() => handleOnClick(category.category,VARIABLES, category.variables)}>
                                     <FontBody1 variant={(selectedTab === `${category.category}/${VARIABLES}`) ? FONT_VARIANT.BOLD : FONT_VARIANT.DEFAULT}>Variables</FontBody1>
                                 </li>
                             </ul>
                         </li>
                       ))
                    }
                </ul>
            </div>
            <div className="content">
                <GridLineLayout>
                    <GridLine backgroudColor={BackgroundColor.LIGHT} settings={{ columns: [{ width: 2 }] }} columns={[
                        <GridLineItem>
                            <ul>
                                {
                                    tabContent.map((event, i) => {
                                        return (<li key={`${i}`} style={{ height: '34px', lineHeight: '18px' }}>
                                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>"{event.title}"</FontBody2>
                                            <FontBody2 color={FONT_COLOR.PRIMARY2}>&nbsp;-&nbsp;{event.helpText}</FontBody2>
                                        </li>)
                                    })
                                }
                            </ul>
                        </GridLineItem>]}>
                    </GridLine>
                </GridLineLayout>
            </div>
        </div>
    </div>)
});

export default VariablesAndEvents;